import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import HigherCommodityDetails from "./components/HigherCommodityDetails";

export default function HigherCommodity() {
  return (
    <Layout>
      <NewsHeader>Why Higher Commodity Prices Hurt Smallholder Farmers — and What Can Be Done to Help</NewsHeader>
      <HigherCommodityDetails />
    </Layout>
  );
}
